import "../styles/Legal.css";

export default function PoliticaCookies() {
  return (
    <div className="legal">
      <div className="legal__card">
        <h1>Política de Cookies</h1>
        <p className="legal__muted">
          Última actualización: {new Date().toLocaleDateString("es-ES")}
        </p>

        <section>
          <h2>¿Qué son las cookies?</h2>
          <p>
            Las cookies son pequeños archivos que se descargan en tu dispositivo al
            acceder a una página web. Permiten, entre otras cosas, almacenar y recuperar
            información sobre tus hábitos de navegación o tu dispositivo.
          </p>
        </section>

        <section>
          <h2>¿Qué tipos de cookies usamos?</h2>

          <h3>1) Cookies necesarias</h3>
          <p>
            Son imprescindibles para el funcionamiento básico del sitio web (por ejemplo,
            recordar tu elección de cookies o permitir la navegación segura). Estas cookies
            no requieren consentimiento.
          </p>

          <h3>2) Cookies analíticas (opcional)</h3>
          <p>
            Nos ayudan a entender cómo se usa la web (páginas más visitadas, tiempo de
            navegación, errores) para mejorar la experiencia. Solo se activan si las aceptas.
          </p>

          <h3>3) Cookies de marketing/publicidad (opcional)</h3>
          <p>
            Se utilizan para mostrar contenido o anuncios personalizados y medir campañas.
            Solo se activan si las aceptas.
          </p>
        </section>

        <section>
          <h2>¿Cómo puedes gestionar tus cookies?</h2>
          <p>
            Puedes aceptar, rechazar o personalizar las cookies desde el banner de cookies
            cuando accedes por primera vez. También puedes cambiar la configuración de tu
            navegador para bloquear o eliminar cookies.
          </p>
          <ul>
            <li>
              En Chrome: Configuración → Privacidad y seguridad → Cookies y otros datos.
            </li>
            <li>
              En Firefox: Ajustes → Privacidad &amp; Seguridad → Cookies y datos del sitio.
            </li>
            <li>
              En Safari: Preferencias → Privacidad.
            </li>
            <li>
              En Edge: Configuración → Cookies y permisos del sitio.
            </li>
          </ul>
        </section>

        <section>
          <h2>Base legal</h2>
          <p>
            Usamos cookies necesarias por interés legítimo en el funcionamiento del sitio.
            Para cookies analíticas y de marketing, la base legal es tu consentimiento, que
            puedes retirar o modificar.
          </p>
        </section>

        <section>
          <h2>Más información y contacto</h2>
          <p>
            Si tienes dudas sobre nuestra Política de Cookies, puedes contactarnos a través
            de los canales indicados en la web.
          </p>
        </section>
      </div>
    </div>
  );
}
